import React, { Component } from 'react';
import { withRouter, Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Scrollbars } from 'react-custom-scrollbars';

import {userGroupUrlCheck} from '../../../utils/userGroupUrlCheck';
import {checkPermissions} from '../../../utils/permissions';

import {URL_IMG,LOGO_URL} from '../../../configs/urlConfigs';
import * as staticConfigs from '../../../configs/staticConfigs';
import {menuDeactiveAction} from '../../../actions/commonActions';
import * as menuNames from '../../../configs/menuNamesConfigs'; 
import * as labelConfigs from '../../../configs/labelConfigs';

class LeftSidebarComponent extends Component {   
    
    constructor(props){
        super()     
        
        let superMenu = [
            // {name:menuNames.LM_SA_DASHBOARD,route:staticConfigs.ROUTE_DASHBOARD,icon:'las la-desktop'},
            // {name:menuNames.LM_SA_QUOTES,route:staticConfigs.ROUTE_QUOTES,icon:'las la-file-invoice-dollar'},
            // {name:menuNames.LM_SA_EVENTS,route:staticConfigs.ROUTE_EVENTS,icon:'las la-calendar-day'},
            // {name:menuNames.LM_SA_AFFILIATES,route:staticConfigs.ROUTE_AFFILIATES,icon:'las la-users-cog'},
            // {name:menuNames.LM_SA_CLIENTS,route:staticConfigs.ROUTE_CLIENTS,icon:'las la-user-tie'},
            // //{name:'Crew List',route:staticConfigs.ROUTE_CREW,image:'crewlist-icon.svg'},
            // {name:menuNames.LM_SA_FEEDBACK,route:staticConfigs.ROUTE_FEEDBACK,icon:'lar la-comments'},
            // {name:menuNames.LM_SA_ASSOCIATES,route:staticConfigs.ROUTE_ASSOCIATES,icon:'las la-user-friends'}, 
            // {name:menuNames.LM_SA_LOGS,route:staticConfigs.ROUTE_LOGS,icon:'las la-history'},

        ]; 
        let affiliateMenu = [ 
            // {name:menuNames.LM_AFLT_DASHBOARD,route:staticConfigs.ROUTE_AFFILIATE_DASHBOARD,icon:'las la-desktop'},
            // {name:menuNames.LM_AFLT_QUOTES,route:staticConfigs.ROUTE_AFFILIATE_QUOTES,icon:'las la-file-invoice-dollar'},
            // {name:menuNames.LM_AFLT_EVENTS,route:staticConfigs.ROUTE_AFFILIATE_EVENTS,icon:'las la-calendar-day'},
            // {name:menuNames.LM_AFLT_SHIFTS,route:staticConfigs.ROUTE_AFFILIATE_SHIFT,icon:'las la-stream'},
            // {name:menuNames.LM_AFLT_CLIENTS,route:staticConfigs.ROUTE_AFFILIATE_CLIENTS,icon:'las la-user-tie'},
            // {name:menuNames.LM_AFLT_SCHEDULE,route:staticConfigs.ROUTE_AFFILIATE_SCHEDULE_VIEW,icon:'lar la-calendar-check'},
            // {name:menuNames.LM_AFLT_TIMESHEET,route:staticConfigs.ROUTE_AFFILIATE_TIMESHEET,icon:'las la-history'},
            // {name:menuNames.LM_AFLT_CREW_LIST,route:staticConfigs.ROUTE_AFFILIATE_CREW,image:'crewlist-icon.svg'},
            // {name:menuNames.LM_AFLT_UNAVAILABILITY,route:staticConfigs.ROUTE_AFFILIATE_UNAVILABILITY,icon:'las la-user-slash'},
            // {name:menuNames.LM_AFLT_FEEDBACK,route:staticConfigs.ROUTE_AFFILIATE_FEEDBACK,icon:'lar la-comments'},
            // {name:menuNames.LM_AFLT_ASSOCIATES,route:staticConfigs.ROUTE_AFFILIATE_ASSOCIATES,icon:'las la-user-friends'},
            // {name:menuNames.LM_AFLT_LOGS,route:staticConfigs.ROUTE_AFFILIATE_LOGS,icon:'las la-file-alt'},   
        ]; 
        let clientMenu = [
            {name:menuNames.LM_CLIENT_DASHBOARD,route:staticConfigs.ROUTE_CLIENT_DASHBOARD,icon:'las la-desktop'},
            {name:menuNames.LM_CLIENT_QUOTES,route:staticConfigs.ROUTE_CLIENT_QUOTES,icon:'las la-file-invoice-dollar'},
            {name:menuNames.LM_CLIENT_EVENTS,route:staticConfigs.ROUTE_CLIENT_EVENTS,icon:'las la-calendar-day'},
            // {name:'Shift Allocation',route:'#',icon:'las la-stream'},        
            {name:menuNames.LM_CLIENT_TIMESHEET,route:staticConfigs.ROUTE_CLIENT_TIMESHEET,icon:'las la-history'},
            {name:menuNames.LM_CLIENT_FEEDBACK,route:staticConfigs.ROUTE_CLIENT_FEEDBACK,icon:'lar la-comments'},
            {name:menuNames.LM_CLIENT_ASSOCIATES,route:staticConfigs.ROUTE_CLIENT_ASSOCIATES,icon:'las la-user-friends'},
            {name:menuNames.LM_CLIENT_LOGS,route:staticConfigs.ROUTE_CLIENT_LOGS,icon:'las la-file-alt'}, 
        ]; 
        this.state = {
            superMenu:superMenu,
            affiliateMenu:affiliateMenu,
            clientMenu:clientMenu,
            active:'',
            setActive:0
        }
        this.onClickMenu = this.onClickMenu.bind(this);

    }

    static propTypes = {
        location: PropTypes.object.isRequired,
    };

    onClickMenu = (e) => {
        document.getElementById("side-menu").classList.remove('open');
        document.getElementById("push-bar").classList.remove('open');
        document.getElementById("toggle-button").classList.remove('active');
        document.getElementById("right-menu-content").classList.remove('active');
        this.setState({ active: e.currentTarget.id });
        this.props.menuDeactiveAction(e.currentTarget.id);
        if(JSON.stringify(staticConfigs.ROUTE_AFFILIATE_TIMESHEET.split('/')) == JSON.stringify(this.props.location.pathname.split('/').slice(0,3) )){
            window.location.reload();
        }else if(JSON.stringify(staticConfigs.ROUTE_CLIENT_TIMESHEET.split('/')) == JSON.stringify(this.props.location.pathname.split('/').slice(0,3) )){
            window.location.reload();
        }
    }

    renderTooltip(name,props) {
        return (
          <Tooltip id={`tooltip-${name}`}  style={{
            opacity: 0.4,
          }} {...props} >
            {name}
          </Tooltip>
        );
    }

    componentDidUpdate(prevProps,prevState) {
        if (this.props.menuActive && this.props.menuActive.length > 1 && this.props.menuActive !== prevProps.menuActive) {
            this.setState({ active: this.props.menuActive}) 
        }
        

        let location = this.props.location.pathname; 
        let leftMenuActive = ''; 

        if(location.includes(staticConfigs.ROUTE_AFFILIATE_DASHBOARD) || location.includes(staticConfigs.ROUTE_CLIENT_DASHBOARD)){
            leftMenuActive = labelConfigs.LBL_DASHBOARD; 
        } 
        else if(location.includes(staticConfigs.ROUTE_AFFILIATES) || location.includes(staticConfigs.ROUTE_AFFILIATE_PROFILE)){
            leftMenuActive = labelConfigs.LBL_AFFILIATES; 
        }   
        else if(location.includes(staticConfigs.ROUTE_CLIENT_PROFILE)){
            leftMenuActive = labelConfigs.LBL_CLIENTS; 
        }
        else if(location.includes(staticConfigs.ROUTE_QUOTES) || location.includes(staticConfigs.ROUTE_AFFILIATE_QUOTES) || location.includes(staticConfigs.ROUTE_CLIENT_QUOTES)){
            leftMenuActive = labelConfigs.LBL_QUOTES; 
        }
        else if(location.includes(staticConfigs.ROUTE_EVENTS) || location.includes(staticConfigs.ROUTE_AFFILIATE_EVENTS) || location.includes(staticConfigs.ROUTE_CLIENT_EVENTS)){
            leftMenuActive = labelConfigs.LBL_EVENTS; 
        }
        else if(location.includes(staticConfigs.ROUTE_AFFILIATE_SHIFT)){
            leftMenuActive = labelConfigs.LBL_SHIFTS; 
        }
        else if(location.includes(staticConfigs.ROUTE_AFFILIATE_SCHEDULE_SHIFT)){
            leftMenuActive = ''; // labelConfigs.LBL_SCHEDULE; 
        }
        else if(location.includes(staticConfigs.ROUTE_AFFILIATE_FEEDBACK)){
            leftMenuActive = labelConfigs.LBL_FEEDBACK; 
        }
        else if(location.includes(staticConfigs.ROUTE_AFFILIATE_TIMESHEET)){
            leftMenuActive = labelConfigs.LBL_TIMESHEET; 
        }  
        else if(location.includes(staticConfigs.ROUTE_AFFILIATE_TIMESHEET_CREW_BASED)){
            leftMenuActive = labelConfigs.LBL_TIMESHEET; 
        }  
        else if(location.includes(staticConfigs.ROUTE_CLIENTS) || location.includes(staticConfigs.ROUTE_AFFILIATE_CLIENTS)){
            leftMenuActive = menuNames.LM_AFLT_CLIENTS; 
        }
        else if(location.includes(staticConfigs.ROUTE_DASHBOARD)){
            leftMenuActive = labelConfigs.LBL_QUOTES;
        }
        else if(location.includes(staticConfigs.ROUTE_AFFILIATE_CERTIFICATES)){
            leftMenuActive = labelConfigs.LBL_CERTIFICATES;
        }

        if(leftMenuActive && leftMenuActive!==prevState.active) { // leftMenuActive.length > 1 && 
            this.setState({ active: leftMenuActive});
        }

    }

    setMenuActive(location){
        if(location.includes(staticConfigs.ROUTE_AFFILIATES) || location.includes(staticConfigs.ROUTE_AFFILIATE_PROFILE)){
            this.setState({ active: labelConfigs.LBL_AFFILIATES})
        }   
        else if(location.includes(staticConfigs.ROUTE_CLIENT_PROFILE)){
            this.setState({ active: labelConfigs.LBL_CLIENTS})
        }
        else if(location.includes(staticConfigs.ROUTE_QUOTES) || location.includes(staticConfigs.ROUTE_AFFILIATE_QUOTES) || location.includes(staticConfigs.ROUTE_CLIENT_QUOTES)){
            this.setState({ active: labelConfigs.LBL_QUOTES})
        }
        else if(location.includes(staticConfigs.ROUTE_EVENTS) || location.includes(staticConfigs.ROUTE_AFFILIATE_EVENTS) || location.includes(staticConfigs.ROUTE_CLIENT_EVENTS)){
            this.setState({ active: labelConfigs.LBL_EVENTS})
        }
        else if(location.includes(staticConfigs.ROUTE_AFFILIATE_SHIFT)){
            this.setState({ active: labelConfigs.LBL_SHIFTS})
        }
        else if(location.includes(staticConfigs.ROUTE_AFFILIATE_SCHEDULE_SHIFT)){
            this.setState({ active: labelConfigs.LBL_SCHEDULE})
        } 
        else if(location.includes(staticConfigs.ROUTE_AFFILIATE_TIMESHEET)){
            this.setState({ active: labelConfigs.LBL_TIMESHEET})
        }
        else if(location.includes(staticConfigs.ROUTE_AFFILIATE_CERTIFICATES)){
            this.setState({ active: labelConfigs.LBL_CERTIFICATES})
        }
        // console.log('location: '+location); 
    }

    componentDidMount(){
        this.setMenuActive(this.props.location.pathname);
    }

    render(){

        const { location } = this.props;

        let userGroupData = userGroupUrlCheck(location);
        let userGroup = ''; 
        if(userGroupData!==undefined){
            userGroup = userGroupData.user_group; 
        }
        let isLogView = checkPermissions("logs","view");
        let isClientView = checkPermissions("client","view");
        let isCrewView = checkPermissions("crew","view");
        let isAssociateUserView = checkPermissions("associateusers","view");
        let isScheduleView = checkPermissions("schedule","view");
        let isQuotesView = checkPermissions("quotes","view");
        let isEventsView = checkPermissions("events","view");
        let isCrewUnavailabilityView = checkPermissions("crewunavailability","view");
        let isFeedbackView = checkPermissions("feedback","view");
        let isTimesheetView = checkPermissions("timesheet","view");
        let isAffiliateView = checkPermissions("affiliate","view");
        let isReportsView = checkPermissions("reports","view");
        let isCertificateView = checkPermissions("certificates","view");
        let isSettingsView = userGroup!==staticConfigs.LOGIN_CLIENT_GROUP ? true : false; 

        let {affiliateMenu,superMenu} = this.state;
        affiliateMenu = [];
        superMenu = [];

        let SuperQuoteResult = superMenu.find( ({ name }) => name === menuNames.LM_SA_QUOTES );
        let SuperEventResult = superMenu.find( ({ name }) => name === menuNames.LM_SA_EVENTS );
        let SuperAffiliateResult = superMenu.find( ({ name }) => name === menuNames.LM_SA_AFFILIATES );
        let SuperClientResult = superMenu.find( ({ name }) => name === menuNames.LM_SA_CLIENTS );
        let SuperfeedbackResult = superMenu.find( ({ name }) => name === menuNames.LM_SA_FEEDBACK );
        let SuperAssociateResult = superMenu.find( ({ name }) => name === menuNames.LM_SA_ASSOCIATES );
        let SuperLogResult = superMenu.find( ({ name }) => name === menuNames.LM_SA_LOGS );
        let SuperSettings = superMenu.find( ({ name }) => name === menuNames.LM_SA_SETTINGS );

        if(isQuotesView){
            if(!SuperQuoteResult)
            superMenu.push({name:menuNames.LM_SA_QUOTES,route:staticConfigs.ROUTE_QUOTES,icon:'las la-file-invoice-dollar'});
        }
        if(isEventsView){
            if(!SuperEventResult)
            superMenu.push({name:menuNames.LM_SA_EVENTS,route:staticConfigs.ROUTE_EVENTS,icon:'las la-calendar-day'});
        }
        if(isAffiliateView){
            if(!SuperAffiliateResult)
            superMenu.push({name:menuNames.LM_SA_AFFILIATES,route:staticConfigs.ROUTE_AFFILIATES,icon:'las la-users-cog'});
        }
        if(isClientView){
            if(!SuperClientResult)
            superMenu.push({name:menuNames.LM_SA_CLIENTS,route:staticConfigs.ROUTE_CLIENTS,icon:'las la-user-tie'});
        }
        if(isFeedbackView){
            if(!SuperfeedbackResult)
            superMenu.push({name:menuNames.LM_SA_FEEDBACK,route:staticConfigs.ROUTE_FEEDBACK,icon:'lar la-comments'});
        }
        if(isAssociateUserView){
            if(!SuperAssociateResult)
            superMenu.push({name:menuNames.LM_SA_ASSOCIATES,route:staticConfigs.ROUTE_ASSOCIATES,icon:'las la-user-friends'});
        }
        if(isLogView){
            if(!SuperLogResult)
            superMenu.push({name:menuNames.LM_SA_LOGS,route:staticConfigs.ROUTE_LOGS,icon:'las la-history'});
        }
        if(isSettingsView && !SuperSettings) { 
            superMenu.push({name:menuNames.LM_SA_SETTINGS,route:staticConfigs.ROUTE_SA_SETTINGS,icon:'las la-cog'});            
        }
        

        let dashboardResult = affiliateMenu.find( ({ name }) => name === menuNames.LM_AFLT_DASHBOARD );
        let timeSheetResult = affiliateMenu.find( ({ name }) => name === menuNames.LM_AFLT_TIMESHEET );
        let unavailabilityResult = affiliateMenu.find( ({ name }) => name === menuNames.LM_AFLT_UNAVAILABILITY );
        let feedBackResult = affiliateMenu.find( ({ name }) => name === menuNames.LM_AFLT_FEEDBACK );
        let logResult = affiliateMenu.find( ({ name }) => name === menuNames.LM_AFLT_LOGS );
        let clientsResult = affiliateMenu.find( ({ name }) => name === menuNames.LM_AFLT_CLIENTS );
        let crewsResult = affiliateMenu.find( ({ name }) => name === menuNames.LM_AFLT_CREW_LIST );
        let shiftsResult = affiliateMenu.find( ({ name }) => name === menuNames.LM_AFLT_SHIFTS );
        let quotesResult = affiliateMenu.find( ({ name }) => name === menuNames.LM_AFLT_QUOTES );
        let associateResult = affiliateMenu.find( ({ name }) => name === menuNames.LM_AFLT_ASSOCIATES );
        let scheduleResult = affiliateMenu.find( ({ name }) => name === menuNames.LM_AFLT_SCHEDULE );
        let eventResult = affiliateMenu.find( ({ name }) => name === menuNames.LM_AFLT_EVENTS );
        let reportsResult = affiliateMenu.find( ({ name }) => name === menuNames.LM_AFLT_REPORTS );
        let certificatesResult = affiliateMenu.find( ({ name }) => name === menuNames.LM_AFLT_CERTIFICATES);
        let settingsResult = affiliateMenu.find( ({ name }) => name === menuNames.LM_AFLT_SETTINGS);

        if(!dashboardResult)
            affiliateMenu.push({name:menuNames.LM_AFLT_DASHBOARD,route:staticConfigs.ROUTE_AFFILIATE_DASHBOARD,icon:'las la-desktop'});
        if(isQuotesView){
            if(!quotesResult)
            affiliateMenu.push({name:menuNames.LM_AFLT_QUOTES,route:staticConfigs.ROUTE_AFFILIATE_QUOTES,icon:'las la-file-invoice-dollar'});
        }
        if(isEventsView){
            if(!eventResult)
            affiliateMenu.push({name:menuNames.LM_AFLT_EVENTS,route:staticConfigs.ROUTE_AFFILIATE_EVENTS,icon:'las la-calendar-day'});
        }
        if(isEventsView){
            if(!shiftsResult)
            affiliateMenu.push({name:menuNames.LM_AFLT_SHIFTS,route:staticConfigs.ROUTE_AFFILIATE_SHIFT,icon:'las la-stream'});
        }
        if(isClientView){
            if(!clientsResult)
            affiliateMenu.push({name:menuNames.LM_AFLT_CLIENTS,route:staticConfigs.ROUTE_AFFILIATE_CLIENTS,icon:'las la-user-tie'});
        }
        if(isScheduleView){
            if(!scheduleResult) { 
                affiliateMenu.push({name:menuNames.LM_AFLT_SCHEDULE,route:staticConfigs.ROUTE_AFFILIATE_SCHEDULE_VIEW,icon:'lar la-calendar-check'});
                affiliateMenu.push({name:menuNames.LM_AFLT_SCHEDULE_CALENDAR,route:staticConfigs.ROUTE_AFFILIATE_SCHEDULE_SHIFT_CALENDAR,icon:'lar la-calendar'});
            }
        }
        if(isTimesheetView){
            if(!timeSheetResult)
            affiliateMenu.push({name:menuNames.LM_AFLT_TIMESHEET,route:staticConfigs.ROUTE_AFFILIATE_TIMESHEET,icon:'las la-history'});
        }
        if(isCrewView){
            if(!crewsResult)
            affiliateMenu.push({name:menuNames.LM_AFLT_CREW_LIST,route:staticConfigs.ROUTE_AFFILIATE_CREW,image:'crewlist-icon-blue.svg',imageAlt:'crewlist-icon.svg'});
        }
        if(isCrewUnavailabilityView){
            if(!unavailabilityResult)
            affiliateMenu.push({name:menuNames.LM_AFLT_UNAVAILABILITY,route:staticConfigs.ROUTE_AFFILIATE_UNAVILABILITY,icon:'las la-user-slash'});
        }
        if(!isReportsView){
            if(!reportsResult)
            affiliateMenu.push({name:menuNames.LM_AFLT_REPORTS,route:staticConfigs.ROUTE_AFFILIATE_REPORTS,icon:'lar la-clipboard',image:'statistics-blue.png',imageAlt:'statistics.png'});
        }
        if(isFeedbackView){
            if(!feedBackResult)
            affiliateMenu.push({name:menuNames.LM_AFLT_FEEDBACK,route:staticConfigs.ROUTE_AFFILIATE_FEEDBACK,icon:'lar la-comments'});
        }
        if(isAssociateUserView){
            if(!associateResult)
            affiliateMenu.push({name:menuNames.LM_AFLT_ASSOCIATES,route:staticConfigs.ROUTE_AFFILIATE_ASSOCIATES,icon:'las la-user-friends'});
        }
        if(isCertificateView){
           if(!certificatesResult)
            affiliateMenu.push({name:menuNames.LM_AFLT_CERTIFICATES,route:staticConfigs.ROUTE_AFFILIATE_CERTIFICATES,icon:'las la-certificate'}); 
        } 
        if(isSettingsView && !settingsResult){
            affiliateMenu.push({name:menuNames.LM_AFLT_SETTINGS,route:staticConfigs.ROUTE_AFFILIATE_SETTINGS,icon:'las la-cog'}); 
        } 
        if(isLogView){
            if(!logResult)
            affiliateMenu.push({name:menuNames.LM_AFLT_LOGS,route:staticConfigs.ROUTE_AFFILIATE_LOGS,icon:'las la-file-alt'});
        }

        // DO NOT ALLOW LEFT MENU ON THESE SPECIFIC URLS 
        let arrLeftMenuNullReturnURLs = ['/', staticConfigs.LOGIN_ROUTE_SUPER_ADMIN, staticConfigs.LOGIN_ROUTE_AFFILIATE, staticConfigs.LOGIN_ROUTE_CLIENT, staticConfigs.ROUTE_VERIFY_EMAIL, staticConfigs.ROUTE_RESET_PASSWORD, staticConfigs.ROUTE_TERMS_ACCEPT, staticConfigs.ROUTE_AFFILIATE_TERMS_ACCEPT, staticConfigs.ROUTE_CLIENT_TERMS_ACCEPT]; 

        if(arrLeftMenuNullReturnURLs.includes(location.pathname)) return null; 
               
        return(
            <nav className="pm-menu-container" id="side-menu">
                {/* <Scrollbars autoHide >  */}
                { (userGroup===staticConfigs.LOGIN_AFFILIATE_GROUP) &&  <div>
                    <div className="logo-wrapper-small">
                        <img src={require('../../../'+URL_IMG+'logo-dark-small-left-menubar.png')} alt={labelConfigs.LBL_APP_NAME} title={labelConfigs.LBL_APP_NAME} />
                    </div>
                    <div className="logo-wrapper-full">
                        <img src={require('../../../'+URL_IMG+'logo-dark-left-menubar.png')} alt={labelConfigs.LBL_APP_NAME} title={labelConfigs.LBL_APP_NAME} /> 
                    </div>
                    <div className="left-menu-items" >
                    { (userGroup===staticConfigs.LOGIN_AFFILIATE_GROUP) && 
                        <ul className="menuLineHeight">
                            {
                                affiliateMenu.map((item,index)  => {
                                    let icon = '', iconAlt = ''; 
                                    // FOR AFFILIATE LEFT MENU OPTIONS "STAFF LIST" & "REPORTS", 'IMGES' ARE USED INSTEAD OF 'ICONS'. SO TO CHANGE COLOR ON 'MOUSE OVER' AND AS 'ACTIVE', WE'VE USED TWO SEPERATE BLUE AND WHITE IMAGES AND SHOW/HIDE THEM ACCORDIGNLY USING CSS 
                                    if(item.image){
                                        icon = <img src={require('../../../'+URL_IMG+item.image)} alt={item.name} className="blueIcon"  />;
                                    }else{
                                        icon = <i className={item.icon}></i>;
                                    }

                                    if(item.imageAlt){
                                        iconAlt = <img src={require('../../../'+URL_IMG+item.imageAlt)} alt={item.name} className="whiteIcon" />;
                                    }

                                    return(
                                        <OverlayTrigger
                                            key={index}
                                            placement="right"
                                            delay={{ show: 250, hide: 400 }}
                                            overlay={this.renderTooltip(item.name)}
                                        >
                                            <li id={item.name} className={this.state.active === item.name ? 'active heigthZero' : 'heigthZero'} onClick={(e) => this.onClickMenu(e)}>
                                                <Link to={item.route} data-toggle="tooltip" data-placement="right">{icon}{iconAlt}<span>{item.name}</span></Link>
                                            </li>
                                        </OverlayTrigger>
                                    )
                                })  
                            }
                    </ul>
                    }
                    </div>  
                </div>    
                }
                { (userGroup!==staticConfigs.LOGIN_AFFILIATE_GROUP) && 
                    <>
                    <div className="logo-wrapper-small">
                        <img src={require('../../../'+URL_IMG+'logo-white-small-left-menubar.png')} alt={labelConfigs.LBL_APP_NAME} title={labelConfigs.LBL_APP_NAME} />
                    </div>
                    <div className="logo-wrapper-full">
                        <img src={require('../../../'+URL_IMG+'logo-white-left-menubar.png')} alt={labelConfigs.LBL_APP_NAME} title={labelConfigs.LBL_APP_NAME} /> 
                    </div>
                    { (userGroup===staticConfigs.LOGIN_SUPER_ADMIN_GROUP) && 
                        <ul className="menuLineHeight"> 
                            {
                                superMenu.map((item,index)  => {
                                    let icon = '';
                                    if(item.image){
                                        icon = <img src={require('../../../'+URL_IMG+item.image)} alt={item.name} />;
                                    }else{
                                        icon = <i className={item.icon}></i>;
                                    }
                                    return(
                                        <OverlayTrigger
                                            key={index}
                                            placement="right"
                                            delay={{ show: 250, hide: 400 }}
                                            overlay={this.renderTooltip(item.name)}
                                        >
                                            <li id={item.name} className={this.state.active === item.name ? 'active heigthZero' : 'heigthZero'} onClick={(e) => this.onClickMenu(e)} key={index}>
                                                <Link to={item.route} data-toggle="tooltip" data-placement="right">{icon} <span>{item.name}</span></Link>
                                            </li>
                                        </OverlayTrigger>
                                    )
                                })  
                            }                                 
                        
                        </ul>
                    }

                    { (userGroup===staticConfigs.LOGIN_CLIENT_GROUP) && 
                        <ul className="menuLineHeight">
                            {
                                this.state.clientMenu.map((item,index)  => {
                                    let icon = '';
                                    if(item.image){
                                        icon = <img src={require('../../../'+URL_IMG+item.image)} alt={item.name} />;
                                    }else{
                                        icon = <i className={item.icon}></i>;
                                    }
                                    return(
                                        <OverlayTrigger
                                            key={index}
                                            placement="right"
                                            delay={{ show: 250, hide: 400 }}
                                            overlay={this.renderTooltip(item.name)}
                                        >
                                            <li id={item.name} className={this.state.active === item.name ? 'active heigthZero' : 'heigthZero'} onClick={(e) => this.onClickMenu(e)}>
                                                <Link to={item.route} data-toggle="tooltip" data-placement="right">{icon} <span>{item.name}</span></Link>
                                            </li>
                                        </OverlayTrigger>
                                    )
                                })  
                            }
                    </ul>
                    }
                    </> 
                }
            </nav>
        )
    }
    
}

const mapStateToProps = (state) => {
    return {
        menuActive: state.commons.menuActive   
    }
};
const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        menuDeactiveAction:menuDeactiveAction  
    },dispatch);
}
export default connect(mapStateToProps,mapDispatchToProps) (withRouter(LeftSidebarComponent));